import $ from 'jquery';

let publicationTitleAdded = false;

export default function () {
  const targetNode = document.querySelector('.nf-form-cont');

  if (!targetNode) {
    return
  }

  const config = { childList: true, subtree: true };

  const callback = (mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        if (!publicationTitleAdded) {
          const publicationTitle = $('.js-publication__title').val();
          if ($('#order-publication-container .nf-form-cont input').length > 0) {
            $('#order-publication-container .nf-form-cont input').first().val(publicationTitle);
            publicationTitleAdded = true;
          }
        }
      }
    });
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
